module.exports = function (THREE) {
  function f1140(p7863, p7864, p7865, p7866) {
    this.x = p7863;
    this.y = p7864;
    this.width = p7865;
    this.height = p7866;
    this.finalX = p7863 + p7865;
    this.finalY = p7864 + p7866;
  }
  f1140.prototype.set = function (p7867, p7868, p7869, p7870, p7871, p7872) {
    this.x = p7867;
    this.y = p7868;
    this.finalX = p7869;
    this.finalY = p7870;
    this.width = p7871;
    this.height = p7872;
    return this;
  };
  f1140.prototype.fits = function (p7873) {
    var v6585 = p7873.image.width;
    var v6586 = p7873.image.height;
    return !!(v6585 <= this.width) && !!(v6586 <= this.height);
  };
  f1140.prototype.fitsPerfectly = function (p7874) {
    var v6587 = p7874.image.width;
    var v6588 = p7874.image.height;
    return v6587 == this.width && v6588 == this.height;
  };
  f1140.prototype.overlaps = function (p7875) {
    return this.x < p7875.x + p7875.width && this.x + this.width > p7875.x && this.y < p7875.y + p7875.height && this.y + this.height > p7875.y;
  };
  function f1141(p7876) {
    this.MAX_TEXTURE_SIZE = 4096;
    if (p7876) {
      this.dataURLs = {};
      for (var v6592 in p7876) {
        var v6590 = p7876[v6592];
        if (v6590 instanceof THREE.CompressedTexture) {
          throw new Error("CompressedTextures are not supported.");
        }
        if (typeof v6590.image.toDataURL == "undefined") {
          var v6591 = document.createElement("canvas");
          v6591.width = v6590.image.naturalWidth;
          v6591.height = v6590.image.naturalHeight;
          v6591.getContext("2d").drawImage(v6590.image, 0, 0);
          this.dataURLs[v6592] = v6591.toDataURL();
        } else {
          this.dataURLs[v6592] = v6590.image.toDataURL();
        }
      }
      this.canvas = document.createElement("canvas");
      this.textureCount = 0;
      this.maxWidth = 0;
      this.maxHeight = 0;
      var vLS22 = "";
      for (var v6592 in p7876) {
        this.textureCount++;
        var v6596 = p7876[v6592];
        v6596.area = v6596.image.width * v6596.image.height;
        if (v6596.image.width > this.maxWidth) {
          this.maxWidth = v6596.image.width;
        }
        if (v6596.image.height > this.maxHeight) {
          this.maxHeight = v6596.image.height;
        }
        vLS22 += v6592 + ",";
      }
      vLS22 = vLS22.substring(0, vLS22.length - 1);
      this.textureCache = {};
      this.node = {};
      this.node.rectangle = new f1140(0, 0, this.maxWidth * this.textureCount, this.maxHeight * this.textureCount);
      this.textureOffsets = {};
      this.allNodes = [];
      this.insert(this.node, this.findNextTexture(p7876), p7876);
      this.ranges = {};
      var v6594 = this.calculateImageSize(p7876);
      this.canvas.width = v6594.width;
      this.canvas.height = v6594.height;
      var v6595 = this.canvas.getContext("2d");
      this.context = v6595;
      for (v6592 in this.textureOffsets) {
        var v6596 = p7876[v6592];
        var v6597 = this.textureOffsets[v6592].x;
        for (var v6598 = this.textureOffsets[v6592].y, v6599 = v6596.image.width, v6600 = v6596.image.height, vV6598 = v6598; vV6598 < v6598 + v6600; vV6598 += v6600) {
          for (var vV6597 = v6597; vV6597 < v6597 + v6599; vV6597 += v6599) {
            v6595.drawImage(v6596.image, vV6597, vV6598, v6599, v6600);
          }
        }
        var vO197 = {
          startU: v6597 / v6594.width,
          endU: (v6597 + v6599) / v6594.width,
          startV: 1 - v6598 / v6594.height,
          endV: 1 - (v6598 + v6600) / v6594.height,
          width: v6599
        };
        this.ranges[v6592] = vO197;
      }
      this.makeCanvasPowerOfTwo();
      this.mergedTexture = new THREE.CanvasTexture(this.canvas);
      this.mergedTexture.wrapS = THREE.ClampToEdgeWrapping;
      this.mergedTexture.wrapT = THREE.ClampToEdgeWrapping;
      this.mergedTexture.minFilter = THREE.NearestFilter;
      this.mergedTexture.magFilter = THREE.NearestFilter;
      this.mergedTexture.needsUpdate = true;
    }
  }
  f1141.prototype.isTextureAlreadyInserted = function (p7877, p7878) {
    var v6601 = p7878[p7877];
    var v6602 = this.dataURLs[p7877];
    for (var v6603 in p7878) {
      if (v6603 != p7877) {
        var v6604 = p7878[v6603];
        var v6605 = this.dataURLs[v6603];
        if (v6602 == v6605 && v6604.offset.x == v6601.offset.x && v6604.offset.y == v6601.offset.y && v6604.offset.z == v6601.offset.z && v6604.repeat.x == v6601.repeat.x && v6604.repeat.y == v6601.repeat.y && v6604.flipX == v6601.flipX && v6604.flipY == v6601.flipY && v6604.wrapS == v6601.wrapS && v6604.wrapT == v6601.wrapT && this.textureOffsets[v6603]) {
          return this.textureOffsets[v6603];
        }
      }
    }
    return false;
  };
  f1141.prototype.insert = function (p7879, p7880, p7881) {
    var v6606 = p7881[p7880];
    var v6607 = this.isTextureAlreadyInserted(p7880, p7881);
    if (v6607) {
      this.textureOffsets[p7880] = v6607;
      var v6632 = this.findNextTexture(p7881);
      if (v6632 != null) {
        this.insert(p7879, v6632, p7881);
      }
      return;
    }
    var v6609 = v6606.image.width;
    var v6610 = v6606.image.height;
    if (p7879.upperNode) {
      var v6611;
      var v6612 = this.maxWidth * this.textureCount + this.maxHeight * this.textureCount;
      var vLN01046 = 0;
      var v6613 = false;
      for (var vLN01047 = 0; vLN01047 < this.allNodes.length; vLN01047++) {
        v6611 = this.allNodes[vLN01047];
        if (!v6611.textureName && v6611.rectangle.fits(v6606)) {
          this.textureOffsets[p7880] = {
            x: v6611.rectangle.x,
            y: v6611.rectangle.y
          };
          var v6614 = this.calculateImageSize(p7881);
          var v6615 = v6614.width + v6614.height;
          if (v6615 < v6612 && v6614.width <= this.MAX_TEXTURE_SIZE && v6614.height <= this.MAX_TEXTURE_SIZE) {
            var v6616 = false;
            for (var v6617 in this.textureOffsets) {
              if (v6617 != p7880) {
                var v6618 = v6611.rectangle;
                var v6619 = this.textureOffsets[v6617].x;
                var v6620 = this.textureOffsets[v6617].y;
                var v6621 = p7881[v6617].image;
                var v6622 = new f1140(v6618.x, v6618.y, v6609, v6610);
                var v6623 = new f1140(v6619, v6620, v6621.width, v6621.height);
                if (v6622.overlaps(v6623)) {
                  v6616 = true;
                }
              }
            }
            if (!v6616) {
              v6612 = v6615;
              vLN01046 = this.allNodes[vLN01047];
              v6613 = true;
            }
          }
          delete this.textureOffsets[p7880];
        }
      }
      if (v6613) {
        this.textureOffsets[p7880] = {
          x: vLN01046.rectangle.x,
          y: vLN01046.rectangle.y
        };
        vLN01046.textureName = p7880;
        if (!vLN01046.children) {
          var vO200 = {};
          var vO201 = {};
          vO200.upperNode = vLN01046;
          vO201.upperNode = vLN01046;
          vLN01046.children = [vO200, vO201];
          var v6624 = vLN01046.rectangle.x;
          var v6625 = vLN01046.rectangle.y;
          var v6626 = this.maxWidth * this.textureCount;
          var v6627 = this.maxHeight * this.textureCount;
          vO200.rectangle = new f1140(v6624 + v6609, v6625, v6626 - (v6624 + v6609), v6627 - v6625);
          vO201.rectangle = new f1140(v6624, v6625 + v6610, v6626 - v6624, v6627 - (v6625 + v6610));
          this.allNodes.push(vO200);
          this.allNodes.push(vO201);
        }
        var v6632 = this.findNextTexture(p7881);
        if (v6632 != null) {
          this.insert(p7879, v6632, p7881);
        }
      } else {
        throw new Error("Error: Try to use smaller textures.");
      }
    } else {
      var v6629 = p7879.rectangle.width;
      var v6630 = p7879.rectangle.height;
      p7879.textureName = p7880;
      var vO200 = {};
      var vO201 = {};
      vO200.upperNode = p7879;
      vO201.upperNode = p7879;
      p7879.children = [vO200, vO201];
      vO200.rectangle = new f1140(v6609, 0, v6629 - v6609, v6610);
      vO201.rectangle = new f1140(0, v6610, v6629, v6630 - v6610);
      this.textureOffsets[p7880] = {
        x: p7879.rectangle.x,
        y: p7879.rectangle.y
      };
      var v6631 = p7879.children[0];
      this.allNodes = [p7879, vO200, vO201];
      var v6632 = this.findNextTexture(p7881);
      if (v6632 != null) {
        this.insert(v6631, v6632, p7881);
      }
    }
  };
  f1141.prototype.makeCanvasPowerOfTwo = function (p7882) {
    var v6633 = false;
    if (!p7882) {
      p7882 = this.canvas;
      v6633 = true;
    }
    var v6634 = p7882.width;
    var v6635 = p7882.height;
    var v6636 = Math.pow(2, Math.round(Math.log(v6634) / Math.log(2)));
    var v6637 = Math.pow(2, Math.round(Math.log(v6635) / Math.log(2)));
    var v6638 = document.createElement("canvas");
    v6638.width = v6636;
    v6638.height = v6637;
    v6638.getContext("2d").drawImage(p7882, 0, 0, v6636, v6637);
    if (v6633) {
      this.canvas = v6638;
    }
  };
  f1141.prototype.calculateImageSize = function (p7883) {
    var vLN01048 = 0;
    var vLN01049 = 0;
    for (var v6639 in this.textureOffsets) {
      var v6640 = p7883[v6639];
      var v6641 = v6640.image.width;
      var v6642 = v6640.image.height;
      var v6643 = this.textureOffsets[v6639].x;
      var v6644 = this.textureOffsets[v6639].y;
      if (v6643 + v6641 > vLN01048) {
        vLN01048 = v6643 + v6641;
      }
      if (v6644 + v6642 > vLN01049) {
        vLN01049 = v6644 + v6642;
      }
    }
    return {
      width: vLN01048,
      height: vLN01049
    };
  };
  f1141.prototype.findNextTexture = function (p7884) {
    var v6645;
    var v6646 = -1;
    for (textureName in p7884) {
      var v6647 = p7884[textureName];
      if (!this.textureCache[textureName] && v6647.area > v6646) {
        v6646 = v6647.area;
        v6645 = textureName;
      }
    }
    if (v6646 == -1) {
      return null;
    } else {
      this.textureCache[v6645] = true;
      return v6645;
    }
  };
  f1141.prototype.rescale = function (p7885, p7886) {
    var v6648 = document.createElement("canvas");
    v6648.width = p7885.width * p7886;
    v6648.height = p7885.height * p7886;
    var v6649 = v6648.getContext("2d");
    v6649.drawImage(p7885, 0, 0, p7885.width, p7885.height, 0, 0, v6648.width, v6648.height);
    return v6648;
  };
  return f1141;
};